import styled from 'styled-components';
import {Scrollbars} from "react-custom-scrollbars";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  height: 340px;
`

export const ModalBody = styled(Scrollbars)`
  width: 100%;
  height: 175px;
`

export const Row = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid rgba(98, 147, 97, 0.15);
`

export const RowContent = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  font-size: 14px;
  border-right: 1px solid rgba(98, 147, 97, 0.15);
`

export const Content = styled.div`
  display: flex;
  padding: 5px 15px;
  align-items: center;
  justify-content: space-between;

  > div:first-child {
    width: 80px;
  }
`

export const Input = styled.input`
  width: 109px;
  margin-left: 58px;
  outline: none;
  text-decoration: aqua;
  border-bottom: 1px solid #7CBE7B;
`
export const ButtonContainer = styled.div`
  display: flex;
  width: 10%;
  height: 35px;
  justify-content: center;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`
